<template>

<div>
    <input :class="['date-input', { error: dateError }]" :disabled="disabled" type="text" :value="displayValue" @keyup="handleInput" @blur="handleBlur" placeholder="mm / dd / yyyy">
</div>

</template>

<script>
// Credit for vanilla javascript (non-vue.js): https://codepen.io/tutsplus/pen/KMWqRr
export default {
    props: ['value', 'disabled', 'max' ],
    data() {
        return {
            displayValue: null,
            dateError: false
        }
    },
    mounted() {
        this.formatDate(this.value)
    },
    watch: {
        value(newVal, oldVal) {
            this.formatDate(newVal)
        }
    },
    methods: {
        formatDate(value) {
            if (!value) {
                return
            }
            var input = value;
            var values = input.split('-').map(function(v, i) {
                return v.replace(/\D/g, '')
            });
            var output = '';
            if (values.length == 3) {
                //var year = values[0].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[0]);
                var year = parseInt(values[0]);
                var month = parseInt(values[1]) - 1;
                var day = parseInt(values[2]);
                var d = new Date(year, month, day);
                if (!isNaN(d)) {
                    var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
                    output = dates.map(function(v) {
                        v = v.toString();
                        return v.length == 1 ? '0' + v : v;
                    }).join(' / ');
                };
            };
            this.displayValue = output;
        },
        checkValue(str, max) {
            if (str.charAt(0) !== '0' || str == '00') {
                var num = parseInt(str);
                if (isNaN(num) || num <= 0 || num > max) num = 1;
                str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
            };
            return str;
        },
        handleInput(e) {
            var input = e.target.value;
            if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
            var values = input.split('/').map(function(v) {
                return v.replace(/\D/g, '')
            });
            if (values[0]) values[0] = this.checkValue(values[0], 12);
            if (values[1]) values[1] = this.checkValue(values[1], 31);
            var output = values.map(function(v, i) {
                return v.length == 2 && i < 2 ? v + ' / ' : v;
            });
            e.target.value = output.join('').substr(0, 14);
            let emittedValue = values[2] || 0 + '-' + values[0] || 0 + '-' + values[1] || 0
            // NOTE: brutish way to handle formatted empty date
            if (emittedValue != '0-') {
                this.$emit('input', emittedValue)
            }
        },
        handleBlur(e) {
            if (!this.value || this.value == '0') return
            if (!e.target.value || e.target.value == '0') return

            var input = e.target.value;
            var values = input.split('/').map(function(v, i) {
                return v.replace(/\D/g, '')
            });
            var output = '';

            if (values.length == 3) {
                //var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
                var year = parseInt(values[2]);
                var month = parseInt(values[0]) - 1;
                var day = parseInt(values[1]);
                var d = new Date(year, month, day);
                if (!isNaN(d)) {
                    var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
                    output = dates.map(function(v) {
                        v = v.toString();
                        return v.length == 1 ? '0' + v : v;
                    }).join(' / ');
                };
            } else {
                return
            }

            let emittedValue = year + '-' + (month + 1).toString().padStart(2, "0") + '-' + day.toString().padStart(2, "0")
            // NOTE: brutish way to handle formatted empty date
            if (emittedValue != '0-') {
                this.$emit('input', emittedValue)
            }
        }
    }
}
</script>
